import { useAuth } from '@BUP/hooks';
import { BraveBupAPI } from '@BUP/services/Axios';

export function useSendMessage(mainMessage) {
  const { user } = useAuth();

  const handleSendMessage = async (comment) => {
    try {
      const userEnrollmentId = user?.enrollmentId;
      let newComment = {}
      if(mainMessage) {
        newComment = {
          ...comment,
          state: 'OPEN',
          enrollmentId: userEnrollmentId,
          parent_comment_id: mainMessage.id
        }
      }else{
        newComment = {
          ...comment,
          state: 'OPEN',
          enrollmentId: userEnrollmentId
        }
      }
      const response = await BraveBupAPI.post('/comments', newComment);
      return response;
    } catch (e) {
      console.log("handleSendMessage E", e)
      throw e;
    }
  }

  return {
    handleSendMessage
  };
}
